export const ROLES = {
    ADMINISTRADOR: "1",
    CORPORATIVO: "2",
    ASESORES: "3",
    CREDITOS: "4",
    COBRANZA: "5",
    OFICINA: "6",
    ALMACEN: "7",
    CONTABILIDAD: "8",
    CALLCENTER: "9",
    RRHH: "10",
    LOGISTICA: "11",
};

export const ROLE_GROUPS = {
    MAIN: [ROLES.ADMINISTRADOR, ROLES.ASESORES, ROLES.CREDITOS, ROLES.COBRANZA],
    ADMIN_ONLY: [ROLES.ADMINISTRADOR],
    PLANNING_TEAM: [ROLES.ADMINISTRADOR, ROLES.CORPORATIVO, ROLES.OFICINA],
    REGISTER_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.CORPORATIVO,
        ROLES.ASESORES,
        ROLES.CONTABILIDAD,
        ROLES.ALMACEN,
        ROLES.COBRANZA,
        ROLES.CREDITOS,
    ],
    CREDIT_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.ASESORES,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
        ROLES.CALLCENTER,
    ],
    CREDIT_INT_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
        ROLES.CALLCENTER,
    ],
    CARDS_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.ASESORES,
        ROLES.CALLCENTER,
        ROLES.CONTABILIDAD,
    ],
    VERIFY_TEAM: [ROLES.ADMINISTRADOR, ROLES.ASESORES],
    FM_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.ASESORES,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
        ROLES.CALLCENTER,
        ROLES.CONTABILIDAD,
    ],
    INSTALLMENT_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
        ROLES.CONTABILIDAD,
        ROLES.CALLCENTER,
    ],
    RECEIPTS_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.ASESORES,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
    ],
    REGISTER_RESUME: [
        ROLES.ADMINISTRADOR,
        ROLES.CONTABILIDAD,
        ROLES.CALLCENTER,
        ROLES.COBRANZA,
        ROLES.ALMACEN,
    ],
    REGISTER_KPI: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD, ROLES.COBRANZA],
    REGISTER_CITY: [
        ROLES.ADMINISTRADOR,
        ROLES.CONTABILIDAD,
        ROLES.CALLCENTER,
        ROLES.COBRANZA,
        ROLES.ALMACEN,
    ],
    ADVISORS_TEAM: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD, ROLES.COBRANZA],
    COMISIONES_TEAM: [ROLES.ADMINISTRADOR, ROLES.RRHH, ROLES.ASESORES],
    STOCK_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.CONTABILIDAD,
        ROLES.COBRANZA,
        ROLES.CALLCENTER,
        ROLES.ALMACEN,
        ROLES.ASESORES,
    ],
    FMSTATS_TEAM: [ROLES.ADMINISTRADOR, ROLES.COBRANZA, ROLES.ASESORES],
    FEESTATS_TEAM: [
        ROLES.ADMINISTRADOR,
        ROLES.CREDITOS,
        ROLES.COBRANZA,
        ROLES.ASESORES,
    ],
    SEMAFORO_TEAM: [ROLES.ADMINISTRADOR],
    SMS_CAMPAIGNS: [ROLES.ADMINISTRADOR],
    WARRANTIES_TEAM: [ROLES.ADMINISTRADOR, ROLES.ASESORES],
    PAYJOY_AUDIT: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD, ROLES.COBRANZA],
    REPORTS_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN, ROLES.ASESORES, ROLES.COBRANZA],
    ACCOUNTING_TEAM: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD],
    // Acceso general al módulo:
    // administrador, asesor, almacén y contabilidad.
    INVENTORY_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN, ROLES.CONTABILIDAD, ROLES.LOGISTICA],

    // Solo el administrador puede configurar permisos.
    INVENTORY_ADMIN: [ROLES.ADMINISTRADOR],

    // Pedidos:
    // administrador y contabilidad.
    INVENTORY_ORDERS_TEAM: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD],

    // Recepciones:
    // administrador y almacén.
    INVENTORY_RECEIPTS_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN, ROLES.LOGISTICA],

    // Traslados:
    // administrador y almacén.
    INVENTORY_TRANSFERS_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN],

    // Salidas operativas:
    // administrador y almacén.
    INVENTORY_EXITS_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN],

    // Devoluciones:
    // administrador y almacén.
    INVENTORY_RETURNS_TEAM: [ROLES.ADMINISTRADOR, ROLES.ALMACEN],

    // Configuración RUC por ciudad:
    // inicialmente solo administrador.
    INVENTORY_RUC_TEAM: [ROLES.ADMINISTRADOR],

    // Auditoría:
    // administrador y contabilidad.
    INVENTORY_AUDIT_TEAM: [ROLES.ADMINISTRADOR, ROLES.CONTABILIDAD],
};
